// English label dictionary for the admin UI. The VN pilot ships English-only;
// the CZ fork (Block 3) adds a sibling `cs.ts` mirroring these keys 1:1 and flips
// the active language. DB enum values stay English — only display labels translate.
export const en = {
  translation: {
    nav: {
      myDay: "My Day",
      inbox: "Inbox",
      sales: "Sales",
      operations: "Operations",
      finance: "Finance",
      content: "Content",
      marketing: "Marketing",
      system: "System",
    },
    common: {
      admin: "Admin",
      settings: "Settings",
      logout: "Log out",
    },
  },
};

export type Resources = typeof en;
